import OutlineSeven from '@assets/icons/outline-seven.svg'
import { Icon } from './Icon'

export const OutlineSevenIcon = Icon(OutlineSeven)
